import { Typography } from "@mui/material";
import { Trans } from "@lingui/react/macro";
import React from "react";
import Link from "@/components/core/localized-mui-link";

interface LoginToSaveProductProps {
  item: {
    id: string;
    name: string;
  };
}

const LoginToSaveProduct: React.FC<LoginToSaveProductProps> = ({ item }) => {
  return (
    <Trans>
      You must
      <Link href="/login" data-testid="alert-login">
        <Typography
          component="span"
          sx={{
            px: "4px",
            fontSize: "14px",
            color: "primary.main",
            cursor: "pointer",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          login
        </Typography>
      </Link>
      or create an account to save
      <Link href={`/product/${item.id}`} data-testid="alert-product">
        <Typography
          component="span"
          sx={{
            px: "4px",
            fontSize: "14px",
            color: "primary.main",
            cursor: "pointer",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          {item.name}
        </Typography>
      </Link>
      to your
      <Link href="/account/wishlist" data-testid="alert-wishlist">
        <Typography
          component="span"
          sx={{
            px: "4px",
            fontSize: "14px",
            color: "primary.main",
            cursor: "pointer",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          wish list
        </Typography>
      </Link>
      !
    </Trans>
  );
};

export default LoginToSaveProduct;
